import React, {useState} from 'react'


import ReactFlow, {
    addEdge,
    MiniMap,
    Controls,
    Background,
    useNodesState,
    useEdgesState,
  } from 'react-flow-renderer';



const onInit = (reactFlowInstance) => console.log('flow loaded:', reactFlowInstance);

  
function InnerFamilyTreeView(props) {

    // Original Main States:
    const [nodes, setNodes, onNodesChange] = useNodesState(props.nodes);
    const [edges, setEdges, onEdgesChange] = useEdgesState(props.edges);
    const onConnect = (params) => setEdges((eds) => addEdge(params, eds));

  return (
    <div style={{width: '100%', height:'56vh', backgroundColor:"#fff"}}>
        <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            onInit={onInit}
            fitView
        // attributionPosition="top-right"
        >
        
            <MiniMap
                nodeStrokeColor={(n) => {
                if (n.style?.background) return n.style.background;
                if (n.type === 'myfamily') return 'red';
                if (n.type === 'son') return '#ff0072';
                if (n.type === 'brother') return  'blue';
                if (n.type === 'sister' ) return 'skyblue';
                if (n.type === 'father') return  'green';
                if (n.type === 'mother') return  'lightgreen';
                if (n.type === 'mama') return  'orange';
                if (n.type === 'daughter') return  'brown';
                if (n.type === 'maushi') return  'maroon';
                if (n.type === 'aatya') return  'magenta';
                if (n.type === 'custom') return  'grey';
                if (n.type === '') return  '#ccc';


                return '#eee';
                }}
                nodeColor={(n) => {
                if (n.style?.background) return n.style.background;

                return '#fff';
                }}
                nodeBorderRadius={2}
            />
            <Controls />
            <Background color="#aaa" gap={16} />
        </ReactFlow>


    </div>
  )
}

export default InnerFamilyTreeView